(function ($) {
  jQuery(document).ready(function(){

    function openModalMessage(mensagem){
      jQuery('.mensagem .item-mensagem').html(mensagem);
      jQuery('.mensagem').addClass('active');
    }

    function isMobile() {
      if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
        return true;
      } else {
          return false;
      }
    }

    //mascara dos inputs
      $('.cep').mask('00000-000');
      $('.phone').mask('(00) 00000-0000');
      $('.cnpj').mask('00.000.000/0000-00', {reverse: true});    
    
      if (isMobile()) {
        //codigos para o mobile aqui
      }else{
        var controller = $.superscrollorama();
        controller.addTween('.topo-cds .seta-baixo', TweenMax.from( $('.galeria'), .80, {css:{opacity:0, top:'500px'}}));
        controller.addTween('.faixa', TweenMax.from( $('.faixa h2'), .80, {css:{opacity:0, marginLeft:'-500px'}}));
        controller.addTween('.faixa', TweenMax.from( $('.azul'), .80, {css:{opacity:0, marginTop:'1000px'}}));
        controller.addTween('.azul .left', TweenMax.from( $('.azul .left .top'), .80, {css:{opacity:0, marginLeft:'-500px'}}));
        controller.addTween('.azul .right', TweenMax.from( $('.azul .right .top'), .80, {css:{opacity:0, marginTop:'500px'}}));
        controller.addTween('.vermelho .left', TweenMax.from( $('.vermelho .left .top'), .80, {css:{opacity:0, marginLeft:'-500px'}}));
        controller.addTween('.vermelho .right', TweenMax.from( $('.vermelho .right .top'), .80, {css:{opacity:0, marginTop:'500px'}}));
        controller.addTween('.vinho .left', TweenMax.from( $('.vinho .left .top'), .80, {css:{opacity:0, marginLeft:'-500px'}}));
        controller.addTween('.vinho .right', TweenMax.from( $('.vinho .right .top'), .80, {css:{opacity:0, marginTop:'500px'}}));
        controller.addTween('.preto .left', TweenMax.from( $('.preto .left .top'), .80, {css:{opacity:0, marginLeft:'-500px'}}));
        controller.addTween('.preto .right', TweenMax.from( $('.preto .right .top'), .80, {css:{opacity:0, marginTop:'500px'}}));
        controller.addTween('.formulario-cds', TweenMax.from( $('.formulario-cds .titulo'), 1.0, {css:{opacity:0, marginLeft:'-1000px'}}));
        controller.addTween('.formulario-cds', TweenMax.from( $('.formulario-cds .formulario'), 1.0, {css:{opacity:0, marginRight:'-1000px'}}));
        controller.addTween('.formulario-cds .formulario', TweenMax.from( $('.folder-cds .container'), 1.0, {css:{opacity:0, marginTop:'500px'}}));      
    }

    if($('#form-cds').length > 0){

      $("#form-cds").submit(function (e) {
        e.preventDefault();
        var form = this;
        $(".load").addClass("active");
      
        grecaptcha.ready(function () {
          grecaptcha
          .execute(google_recaptcha_key, { action: "submit" })
          .then(function (token) {
            var formData = new FormData($(form)[0]);
            formData.append("google_recaptcha_token", token);
            $.ajax({
              url: theme_url + "/ajax/cds.php",
              type: "POST",
              dataType: "json",
              data: formData,
              complete: function (data) {
                $(".load").removeClass("active");
                openModalMessage(data.responseJSON.message);
              },
              success: function () {
                $(form).trigger("reset");
              },
              cache: false,
              contentType: false,
              processData: false,          
            });
          });
        });
      });
    }

    $('.mensagem .close-mensagem').click(function(){
			$('.mensagem').removeClass('active');
		});
  });
})(jQuery);